import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { I2gDialogService } from 'i2g-ng-ui';
import {
  I2gNgTrackingActionBuilder,
  ITrackingAction,
  ITrackingObject,
  ITrackingProperties,
} from 'i2g-ng-tracking';
import { TrackingDialogNamesEnum } from '../../../tracking/tracking.data';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-attachment-error-dialog',
  templateUrl: './attachment-error-dialog.component.html',
  styleUrls: ['./attachment-error-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentErrorDialogComponent implements OnInit {
  @Input() attachFileErrorDescription: string;
  @Input() trackingScreenName: string;
  @Input() errorMessageTrackingAdditionalProperties: ITrackingProperties;

  trackingObject: ITrackingObject;
  trackingAction: ITrackingAction;
  trackingDialogName: TrackingDialogNamesEnum;

  constructor(
    private _dialogService: I2gDialogService,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingDispatcher: TrackingDispatcher,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.trackingDialogName = TrackingDialogNamesEnum.attachment_error;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      this.trackingDialogName
    );
    this.trackingAction = this._trackingActionBuilder.buildPresented(
      this.trackingScreenName
    );
    this._trackingDispatcher.trackEvent(
      this.trackingObject,
      this.trackingAction,
      this.errorMessageTrackingAdditionalProperties
    );
  }

  onSecondaryButtonClicked() {
    this._dialogService.closeDialog();
  }
}
